import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistCombineReducers } from 'redux-persist'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import { syncTranslationWithStore, setLocale as setLocaleRedux } from 'react-redux-i18n'
import 'intl/locale-data/jsonp/en'

import apiMiddleware from './core/api/middleware'
import { middleware as gtmMiddleware } from './gtm'
import config from './persist'
import reducers from './modules'
import { setLocale } from './modules/translations'
import { getCurrentUser } from './modules/users/current'
import { getParameters } from './modules/parameters'
import { getSystem } from './modules/infos/system'
import { getRaised } from './modules/infos/raised'
import { getAbilities } from './modules/infos/abilities'
import { setupSessionProlongation } from 'modules/users/sessions/prolong'

export const history = createHistory()

const rootReducer = persistCombineReducers(config, reducers)
const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history), apiMiddleware]

if (process.env.REACT_APP_GOOGLE_TAG_MANAGER) {
  middleware.push(gtmMiddleware)
}

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers)

const store = createStore(rootReducer, initialState, composedEnhancers)

export const persistor = persistStore(store, null, () => {
  const { i18n: { locale }, users: { authorization } } = store.getState()
  store.dispatch(setLocale(locale))
  if (authorization) {
    store.dispatch(getCurrentUser())
    store.dispatch(setupSessionProlongation())
  }
  store.dispatch(getAbilities())
})

syncTranslationWithStore(store)
store.dispatch(setLocaleRedux('en'))
store.dispatch(getParameters())
store.dispatch(getSystem())
store.dispatch(getRaised())

if (module.hot) {
  module.hot.accept('./modules/', () => {
    const reducers = require('./modules/index').default
    const nextReducer = persistCombineReducers(config, reducers)
    store.replaceReducer(nextReducer)
  })
}

export default store



// WEBPACK FOOTER //
// ./src/store.js